// extracted by mini-css-extract-plugin
export default {"html":"error_html__eKlaI","body":"error_body__0W3WU","section":"error_section__pUH+t","error":"error_error__wggjt","page":"error_page__qwCFO","back-home":"error_back-home__pDaTb"};